import React from 'react';
import { useSelector } from 'react-redux';
import { getHighlights } from '../store/selectors/highlightsSelector';
import { Highlights } from '../Highlights';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import contentGraphDatasource from '@gameday/core/datasources/contentGraph';
import contentDatasource from '@gameday/core/datasources/content';
import highlightsReducer from '../store/reducers/highlightsReducer';

initContainerData.register({
    datasources: {
        contentGraph: contentGraphDatasource,
        content: contentDatasource
    },
    reducers: {
        allHighlights: highlightsReducer
    }
});

export const HighlightsDataContainer = (props) => {
    const highlightsState = useSelector(getHighlights);
    const showMLBTVInfo = !highlightsState?.blockLoginActivities && !!highlightsState?.mlbTVInfo?.tvInfo?.length > 0;
    const { condensedGame, gameRecap } = highlightsState?.highlightVideoData;
    const showHighlightVideos = !!condensedGame || !!gameRecap;
    const showHighlights = showHighlightVideos || showMLBTVInfo;

    return (
        showHighlights &&
        <Highlights
            showHighlightVideos={showHighlightVideos}
            showMLBTVInfo={showMLBTVInfo}
            {...highlightsState}
            {...props}
        />
    );
};
